import { axios } from "../../cores/axiosWrapper";

export const getCollectionsAPI = (apiEndpoint, projectId, params) => {
    return axios.get(`${apiEndpoint}/collections`, { params, headers: { projectId } });
};
